"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Renew;
(function (Renew) {
    Renew[Renew["Immediately"] = -1] = "Immediately";
    Renew[Renew["WhenReady"] = -2] = "WhenReady";
    Renew[Renew["OnDemand"] = -3] = "OnDemand";
    Renew[Renew["Manually"] = -4] = "Manually";
    Renew[Renew["NoCache"] = -5] = "NoCache";
})(Renew = exports.Renew || (exports.Renew = {}));
var ReentrantCall;
(function (ReentrantCall) {
    ReentrantCall[ReentrantCall["ExitWithError"] = 1] = "ExitWithError";
    ReentrantCall[ReentrantCall["WaitAndRestart"] = 0] = "WaitAndRestart";
    ReentrantCall[ReentrantCall["CancelPrevious"] = -1] = "CancelPrevious";
    ReentrantCall[ReentrantCall["RunSideBySide"] = -2] = "RunSideBySide";
})(ReentrantCall = exports.ReentrantCall || (exports.ReentrantCall = {}));
var SeparateFrom;
(function (SeparateFrom) {
    SeparateFrom[SeparateFrom["None"] = 0] = "None";
    SeparateFrom[SeparateFrom["Reaction"] = 1] = "Reaction";
    SeparateFrom[SeparateFrom["Parent"] = 2] = "Parent";
    SeparateFrom[SeparateFrom["Children"] = 4] = "Children";
    SeparateFrom[SeparateFrom["All"] = 7] = "All";
})(SeparateFrom = exports.SeparateFrom || (exports.SeparateFrom = {}));
